// CC-Common imports
import { CCLocalStorageCategory, CCLocalStorageService } from 'cc-common';

// Service imports
import { ScreenService } from '../_services/shared-services/screen.service';
import { HelperService } from '../_services/shared-services/helper.service';

// Component imports
import { BaseComponent } from './mp-base-component';

export class MPBaseComponentWithGrid extends BaseComponent {
    activeHeaderFilterData: any;

    constructor(
        protected readonly screenService: ScreenService,
        protected readonly localStorageService: CCLocalStorageService,
        protected readonly helperService: HelperService
    ) {
        super(screenService);
        this.activeHeaderFilterData = [
            {
                text: 'Active',
                value: null
            },
            {
                text: 'Inactive',
                value: null
            }
        ];
    }

    loadGridState(gridStorageKey) {
        if (gridStorageKey !== null) {
            const state = JSON.parse(this.localStorageService.getItem(gridStorageKey, CCLocalStorageCategory.DXG));
            if (!!state) {
                state.filterValue = null; // clear filter
                state.pageIndex = 0;
                state.focusedRowKey = -1;
                state.selectedRowKeys = []; // clear selection
                state.columns.forEach((column: any) => {
                    column.filterValue = null;
                    column.filterType = null;
                    column.sortIndex = null;
                    column.sortOrder = null;
                    column.groupIndex = null;
                    column.selectedFilterOperation = null;
                });
            }
            return state;
        }
        return null;
    }

    saveGridState(state, gridStorageKey) {
        if (gridStorageKey !== null) {
            this.localStorageService.setItem(gridStorageKey, JSON.stringify(state), CCLocalStorageCategory.DXG);
        }
    }

    calculateCustomSummary(e): void {
        this.helperService.calculateTotalSummary(e);
    }
}
